<div class="row">
  <div class="col-md-12">
    <div id="map" style="width: 100%; height: 600px" #yamaps></div>
  </div>
</div>
